import lazyLoad from '@utils/lazyLoad'
const applicationCode = 'fe215caa-efeb-4646-836a-92cd3904f3d7'

const contentRoutes = [
  {
    path: '/marketing/content/imageTextManagement',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Marketing/Content/ImageTextManagement')
    ),
    meta: {
      applicationCode,
      title: '图文管理列表'
    }
  },
  {
    path: '/marketing/content/imageTextManagement/new',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Marketing/Content/ImageTextManagement/new')
    ),
    meta: {
      applicationCode,
      title: '图文组'
    }
  },
  {
    path: '/marketing/content/imageTextManagement/detail/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Marketing/Content/ImageTextManagement/detail')
    ),
    meta: {
      applicationCode,
      title: '图文详情'
    }
  },
  {
    path: '/marketing/content/templateManageList',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Marketing/Content/TemplateManagement')
    ),
    meta: {
      applicationCode,
      title: '模板管理列表'
    }
  },
  {
    path: '/marketing/content/templateManageList/new',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Marketing/Content/TemplateManagement/new')
    ),
    meta: {
      applicationCode,
      title: '模板'
    }
  },
  {
    path: '/marketing/content/materialManagement',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Marketing/Content/MaterialManagement')
    ),
    meta: {
      layoutMode: 'empty',
      title: '图文素材'
    }
  },
  {
    path: '/marketing/content/MultiMediaMaterial',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Marketing/Content/MultiMediaMaterial')
    ),
    meta: {
      layoutMode: 'empty',
      title: '多媒体素材'
    }
  },
  // 暂时没有找到对应的侧边栏
  {
    path: '/marketing/content/imageTextSetting',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Marketing/Content/ImageTextSetting')
    ),
    meta: {
      applicationCode,
      title: '图文设置'
    }
  },
]

export default contentRoutes
